import { Post } from "services/apiService";
import {
  GET_MANUAL_ORDER_ERROR,
  GET_MANUAL_ORDER_REQUEST,
  GET_MANUAL_ORDER_SUCCESS,
} from "./action-type";
import { BASE_URL } from "services/CONSTANTS";

export const viewManualOrders = (params) => async (dispatch) => {
  // Extract API key, limit, offset, and reqBody from the params (payload)
  const { apiKey, limit, offset, reqBody } = params;
  const apiUrl = `${BASE_URL}orders/@fetchorders?apikey=${apiKey}&offset=${offset}&limit=${limit}`;

  // Dispatch the request action to indicate that the fetch process is starting
  dispatch({ type: GET_MANUAL_ORDER_REQUEST });

  // Perform the POST request to the API using the custom Post function
  Post({
    url: apiUrl, // The constructed URL
    params: reqBody, // The request body (payload)
    config: {}, // Default configuration for axios (can be extended if needed)
  })
    .then((response) => {
      // Success - Dispatch the data
      if (response.status === 200) {
        dispatch({
          type: GET_MANUAL_ORDER_SUCCESS,
          payload: response.data, // Ensure 'orders' is the correct key in response data
        });
      } else {
        // Failure - Dispatch error
        dispatch({
          type: GET_MANUAL_ORDER_ERROR,
          payload: response.data,
        });
      }
    })
    .catch((err) => {
      // Handle network or server errors
      dispatch({
        type: GET_MANUAL_ORDER_ERROR,
        payload: err.response.data,
      });
    });
};
